/**
 * Whether this build can send analytics at all. Without a measurement id
 * nothing can egress, so the consent banner never shows and the visitor's
 * consent stays undecided forever. Anything waiting for the banner to be
 * answered must treat "not configured" as answered.
 */
export const ANALYTICS_CONFIGURED = Boolean(
  process.env.REACT_APP_GA4_MEASUREMENT_ID || process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
);
